import { useEffect, useState } from "react";
import Encarte from "../../../OBJRep/Encarte";
import { useNavigate } from "react-router";

import { createSearchParams } from "react-router-dom";
export default function useCreateEncarte({ token, setNotification }) {
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_SERVER_BASE_URL;

  const createEncarte = async (encarte) => {
    const url = BASE_URL + "encarte-collection/";
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify(encarte),
      headers: {
        Authorization: token,
        "Content-Type": "application/json",
      },
    });
    if (response.ok) {
      const encarte = await response.json();
      navigate({
        pathname: "/editor",
        search: createSearchParams({
          encarteId: encarte.id,
        }).toString(),
      });
    } else if (response.status === 403) {
      setNotification({
        message: "Limite máximo de encartes atingido.",
        type: "error",
      });
    }
  };

  return { createEncarte };
}
